<template>
	<label class="amkeo7da">
		<slot></slot>
	</label>
</template>

<script>
export default {
	name: "j-base-label"
}
</script>

<style src="./index.css" scoped />
